import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import PortalShell from "@/components/PortalShell";
import { LayoutDashboard, Link2, DollarSign, Wallet } from "lucide-react";
import AffiliateApply from "@/pages/affiliate/Apply";
import AffiliateOverview from "@/pages/affiliate/Overview";
import AffiliateLinks from "@/pages/affiliate/Links";
import AffiliateEarnings from "@/pages/affiliate/Earnings";
import AffiliatePayouts from "@/pages/affiliate/Payouts";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const links = [
  { to: "/affiliate", end: true, label: "Overview", icon: LayoutDashboard, testid: "aff-nav-overview" },
  { to: "/affiliate/links", label: "Tracking links", icon: Link2, testid: "aff-nav-links" },
  { to: "/affiliate/earnings", label: "Commission ledger", icon: DollarSign, testid: "aff-nav-earnings" },
  { to: "/affiliate/payouts", label: "Payouts", icon: Wallet, testid: "aff-nav-payouts" },
];

export default function AffiliatePortal() {
  const [profile, setProfile] = useState(undefined); // undefined = loading, null = none, obj = active
  const location = useLocation();

  useEffect(() => {
    api.get("/affiliate/me").then((r) => setProfile(r.data || null)).catch(() => setProfile(null));
  }, []);

  if (profile === undefined) {
    return <div className="max-w-[1400px] mx-auto px-6 py-24 text-slate-500">Loading…</div>;
  }

  // Onboarding not done → send them to the apply page (regardless of subroute)
  if (!profile && !location.pathname.startsWith("/affiliate/apply")) {
    return <Navigate to="/affiliate/apply" replace />;
  }

  return (
    <Routes>
      <Route path="apply" element={<AffiliateApply onComplete={(p) => setProfile(p)} />} />
      <Route path="*" element={
        <PortalShell title="Affiliate" subtitle="Portal" links={links} testid="affiliate-portal">
          <Routes>
            <Route index element={<AffiliateOverview profile={profile} />} />
            <Route path="links" element={<AffiliateLinks profile={profile} />} />
            <Route path="earnings" element={<AffiliateEarnings profile={profile} />} />
            <Route path="payouts" element={<AffiliatePayouts profile={profile} />} />
          </Routes>
        </PortalShell>
      } />
    </Routes>
  );
}
